<template id="list-cmses">
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">
          service location
        </li>
      </ol>
    </nav>
    <!-- List cms -->
    <div class="listCmses" v-if="listCmsMode">
      <div class="row">
        <div class="col-md-4">
          <h3>Service Location</h3>
        </div>
        <div class="col-md-4">
          <searchbox @searchButtonClick="setCurrentKeywordandSearch"></searchbox>
        </div>
        <div class="col-md-4">
          <a href="/service-location/form" class="btn btn-success float-right mr-3">เพิ่ม</a>
        </div>
      </div>
      <paginate v-if="paginate_data._infos._total && !showLoading" :paginate_data="paginate_data"
        @paginateItemClick="setCurrentPageAndSearch"></paginate>
      <general-loading v-if="showLoading"></general-loading>
      <div class="row">
        <div class="col-md-12">
          <div class="card card-body" v-for="item in items" v-bind:key="item.id">
            <div class="row">
              <div class="col-md-1">
                <img v-if="item.desktop_thumbnail_url" :src="item.desktop_thumbnail_url" :alt="item.desktop_thumbnail_alt_text" class="img-thumbnail" />
              </div>
              <div class="col-md-9">
                <h4 class="text">
                  <span v-bind:class="{
                    'text-warning': titleIsNotDefined(item.languages[0].title),
                  }">{{ item.languages[0].title }}</span>
                </h4>
              </div>
              <div class="col-md-2">
                <div class="form-group float-right">
                  <a class="btn btn-light" v-bind:href="'/service-location/form/' + item.id">แก้ไข</a>
                  <button type="button" class="btn btn-danger" data-toggle="modal" data-target="#ConfirmDeleteModal"
                    @click="setForDeleteItemId(item.id)">
                    ลบ
                  </button>
                </div>
              </div>
            </div>
               <div class="row">
              <div class="col-md-12">
                <span
                  ><i class="fa fa-edit" aria-hidden="true"></i
                  >{{ item.updated_at.time_ago }}</span
                >
                <a
                  :href="`${baseUrl}พวงหรีดใกล้วัด/${item.slug}/`"
                  target="_blank"
                  class="text text-info"
                >
                  {{ baseUrl }}พวงหรีดใกล้วัด/{{ item.slug }}/
                </a>
              </div>
              <div class="col-md-6">
                <span
                  class="badge badge-success ml-1"
                  v-for="tag in item.tags"
                  v-bind:key="tag.id"
                >
                  {{ tag.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <paginate v-if="paginate_data._infos._total && !showLoading" :paginate_data="paginate_data"
        @paginateItemClick="setCurrentPageAndSearch"></paginate>
      <div v-if="recordNotFound" class="alert alert-warning" role="alert">
        ไม่พบข้อมูล
      </div>
    </div>
    <!-- delete modal    -->
    <general-delete-modal @ConFirmDeleteClick="performDeleteItem"></general-delete-modal>
    <!-- alert modal    -->
    <button style="display: none" type="button" class="btn btn-primary" data-toggle="modal" data-target="#AlertModal"
      ref="decoyAlertModalClick">
      test
    </button>
    <general-alert-modal :alertMessage="alertMessage"></general-alert-modal>
  </div>
</template>

<script>
import searchbox from "../_layouts/searchbox.vue";
import paginate from "../_layouts/pagination.vue";

export default {
  components: {
    searchbox,
    paginate,
  },
  //props:['paginate_data'],
  data() {
    return {
      baseUrl: this.getBaseUrl(),
      items: [],
      item: {},
      cms_id: "",
      paginate_data: {
        _infos: {},
        _base_item_list_url: "",
      },
      alertMessage: {
        titleClassName: "warning",
        titleMessage: "แจ้งเตือน!!",
        bodyClassName: "warning",
        bodyMessage: "This is alert",
      },
      edit: false,
      recordNotFound: false,
      listCmsMode: true,
      showLoading: true,
      base_item_url: "/service-location",
      currentSearchKeyword: "",
      currentPage: 1,
      currentPerpage: 23,

      //about deletiion
      item_id_for_delete: "",
    };
  },
  mounted() {
    //console.log('Component mounted.')
  },
  created() {
    this.searchItems();
    this.listCmsMode = true;
  },
  methods: {
    getBaseUrl() {
      const host = window.location.hostname;
      if (host.includes("backoffice.wreathmala")) {
        return "https://www.wreathmala.com/";
      } 
      return "https://wre2024-staging.dev-app-bit.com/";
    },
    setCurrentKeywordandSearch(searchKeyword) {
      this.currentPage = 1;
      this.currentSearchKeyword = searchKeyword;
      this.searchItems();
    },
    setCurrentPageAndSearch(page) {
      this.currentPage = page;
      this.searchItems();
    },
    searchItems() {
      let url = "/service-location/list";
      url = url + "?page=" + this.currentPage;
      url = url + "&perpage=" + this.currentPerpage;
      url = url + "&title=" + this.currentSearchKeyword;
      this.fetchItems(url);
    },
     setForDeleteItemId(item_id) {
      this.item_id_for_delete = item_id;
    },
    fetchItems(url) {
      this.showLoading = true;
      this.items = [];
      url = url || "/service-location/list";
      axios
        .get(url)
        .then((response) => {
          this.items = response.data.service_locations;
           this.paginate_data._infos = response.data._infos._paginate;
          this.paginate_data._infos._url_range = this.computePaginate(
            this.paginate_data._infos._last_page
          );
          this.recordNotFound = response.data.service_locations.length == 0 ? true : false;
          this.showLoading = false;
        })
        .catch((errors) => {
          console.log('เกิดข้อผิดพลาด:', errors);
          this.showLoading = false;
        });
    },
    titleIsNotDefined(title) {
      return title == "title-not-defined";
    },
    computePaginate(lastpage) {
      let result = [];
      let i = 0;
      let data = Object.entries(this.paginate_data._infos._url_range);
      data.forEach(function (item) {
        if (item[0] > 0 && item[0] <= lastpage) {
          result[i] = item;
          i++;
        }
      });
      return result;
    },
     performDeleteItem() {
      axios
        .post(this.base_item_url + "/" + this.item_id_for_delete + "/delete")
        .then((response) => {
          this.searchItems();
        })
        .catch((errors) => {
          if (errors.response.data._infos.result) {
            this.alertMessage.bodyMessage = errors.response.data._infos.result;
            this.$refs.decoyAlertModalClick.click();
          } else {
            console.log(errors.response.data._infos.result);
            alert("ไม่สามารถลบได้ " + errors.response.data);
          }
        });
    },
  },
};
</script>